import React, { useContext, useState } from "react";
import MaxWidth from "../../components/styles/max-width";
import Back from "../../components/common/Back";
import SliderFilter from "../../components/common/SliderFilter";
import Sale from "../../components/sales/Sale";
import { Query } from "react-apollo";
import getUndef from "../../lib/get-undef";
import { getSales } from "../../__generated__/getSales";
import { GET_SALES_DATA } from "../../queries/Sales";
import HelmetComponent from "../../components/layout/HelmetComponent";
import { CityContext } from "../../components/context/CityContext";

const Page = () => {
  const { cityNameForSeo, workingHours } = useContext(CityContext);
  const [filterPromo, setFilterPromo] = useState("all");

  return (
    <MaxWidth>
      <Back name="НА ГЛАВНУЮ" href="/" />
      <h2>Скидки и Акции</h2>
      <HelmetComponent
        title={`Скидки и Акции - Доставка еды в ${cityNameForSeo} - МИКАFood`}
        description={`Узнайте о наших скидках и акциях на полюбившиеся блюда от МИКАfood. Полный и актуальный список действующих акций и специальных предложений на нашем сайте. Доставим ${workingHours}`}
      />
      <Query<getSales>
        query={GET_SALES_DATA}
        variables={{
          slug: "promo",
        }}
      >
        {({ loading, error, data }) => {
          if (error || loading) {
            return null;
          }

          const salesItems =
            getUndef(() => data.shop.navigations[0].lineItems) || [];

          const tags = salesItems.reduce((acc, item) => {
            const newTags = {};
            item.tags.forEach((tag) => {
              newTags[tag] = true;
            });
            return { ...acc, ...newTags };
          }, {});

          const options = [
            {
              slug: "all",
              name: "Все",
              id: "1",
            },
          ];

          Object.keys(tags).forEach((key) => {
            options.push({
              slug: key,
              name: key,
              id: key,
            });
          });

          const filteredSalesItems = salesItems.filter((i) =>
            i.tags.find((tag) => tag === filterPromo)
          );

          return (
            <>
              <SliderFilter
                options={options}
                onChange={(value) => setFilterPromo(value)}
              />
              <Sale
                data={filterPromo === "all" ? salesItems : filteredSalesItems}
              />
            </>
          );
        }}
      </Query>
    </MaxWidth>
  );
};

export default Page;
